module.exports = __webpack_public_path__ + "static/media/chameleone.f1e600a9.jpg";